/* By Lilo — dag/nacht hero-scrub.
   Eén CSS-variabele --night (0→1) op <html> stuurt de hele scène.
   Twee inputs, altijd in sync: scroll door de wrapper en de sleepbare zon/maan-scrubber. */
(function () {
  function initHero(root) {
    var wrap = root.closest('.bl-herowrap') || root;
    var track = wrap.querySelector('.bl-hero__track');
    var docEl = document.documentElement;
    var dragging = false;

    function clamp(v) { return Math.max(0, Math.min(1, v)); }
    function setNight(v) { docEl.style.setProperty('--night', v.toFixed(4)); }

    function syncFromScroll() {
      var total = wrap.offsetHeight - window.innerHeight;
      var prog = total > 0 ? clamp(-wrap.getBoundingClientRect().top / total) : 0;
      setNight(prog);
      wrap.classList.toggle('bl-hero-done', wrap.getBoundingClientRect().bottom <= window.innerHeight);
    }

    function dragMove(e) {
      if (!track) return;
      var r = track.getBoundingClientRect();
      var p = clamp((e.clientX - r.left) / r.width);
      setNight(p);
      var total = wrap.offsetHeight - window.innerHeight;
      if (total > 0) window.scrollTo(0, wrap.offsetTop + p * total);
    }

    function onUp() {
      dragging = false;
      window.removeEventListener('pointermove', dragMove);
      window.removeEventListener('pointerup', onUp);
    }

    if (track) {
      track.addEventListener('pointerdown', function (e) {
        dragging = true;
        dragMove(e);
        window.addEventListener('pointermove', dragMove);
        window.addEventListener('pointerup', onUp);
      });
    }

    var onScroll = function () { if (!dragging) syncFromScroll(); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    syncFromScroll();
  }

  function boot() {
    document.querySelectorAll('.bl-hero').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
